import React, {Fragment} from 'react';
import {Order} from '../../../app/models/order';
import CustomerReceiptInvoiceView from "./customer-receipt-invoice-view";
import BankReceiptInvoiceView from "./bank-receipt-invoice-view";

type InvoicePrintViewProps = {
    order: Order
}
const InvoicePrintView = ({order}: InvoicePrintViewProps) => {

    return (
        <Fragment>
            {
                (order.DeliveryType == '1') ? (<CustomerReceiptInvoiceView order={order}/>) : (
                    <BankReceiptInvoiceView order={order}/>)
            }
        </Fragment>
    );
}
;

export default InvoicePrintView;